import * as firebase from 'firebase/app';
import 'firebase/firestore';
import FirebaseGateway from '@/classes/firebaseGateway';
import FirebaseStorageLoader from '@/classes/firebaseStorageLoader';
import { Person } from '@/interfaces/Person';

export default {
  setUser({ commit }, user) {
    commit('setUser', user);
  },

  setUserData({ commit }, userData) {
    commit('setUserData', userData);
  },

  createGroup({ state, commit }, name) {
    const promise = new Promise((resolve) => {
      const members = {};
      const uid = state.user.uid;
      members[uid] = 'admin';
      firebase
        .firestore()
        .collection('groups')
        .add({
          name,
          members,
        })
        .then((docRef) => {
          commit('setCurrentGroup', docRef.id);
          commit('addGroup', docRef);
          resolve(docRef.id);
        });
    });

    return promise;
  },

  async loadGroupData({ commit }, groupId) {
    const groupData = await firebase
      .firestore()
      .collection('groups')
      .doc(groupId)
      .get();
    commit('setCurrentGroupData', groupData.data());
    return groupData;
  },

  resetFight({ commit }) {
    commit('resetFight');
  },

  deletePerson({ state, commit }, id) {
    if (state.currentGroup === null) {
      throw new Error('No group selected');
    }
    return firebase
      .firestore()
      .collection('database')
      .doc(state.currentGroup)
      .collection('people')
      .doc(id)
      .delete()
      .then(() => {
        commit('deletePerson', id);
      });
  },

  saveWorldPerson({ state, commit }, person: Person) {
    if (state.currentGroup === null) {
      throw new Error('No group selected');
    }
    const peopleCollection = firebase
      .firestore()
      .collection('database')
      .doc(state.currentGroup)
      .collection('people');
    if (person.hasOwnProperty('id') && person.id !== null) {
      return peopleCollection
        .doc(person.id)
        .set(person)
        .then(() => {
          commit('addPerson', person);
        });
    } else {
      // Add the current user to this person as the one who added it
      person.addedBy = state.user.uid;

      return peopleCollection.add(person).then((createdDocument) => {
        person.id = createdDocument.id;
        commit('addPerson', person);
      });
    }
  },

  loadImageUrl({state, commit}, person: Person) {
    FirebaseStorageLoader.fetchPersonImageUrl(state.currentGroup, person).then((url) => {
      person.loadedImageUrl = url;
      commit('addPerson', person);
    }).catch((error) => {
      throw new Error(error);
    });
  },

  loadHandoutUrl({ state }, handoutFilename: string) {
    return FirebaseStorageLoader.fetchHandoutUrl(state.currentGroup, handoutFilename);
  },

  loadLibraryItemUrl({ rootGetters }, libraryFilename: string) {
    return FirebaseStorageLoader.fetchLibraryUrl(rootGetters.currentWorld, libraryFilename);
  },

  saveAccountDetails({ state, commit }, details) {
    const gateway = new FirebaseGateway();
    if (details.name) {
      gateway.saveAccountName(state.user.uid, details.name)
        .then(() => {
          commit('setUserName', details.name);
        });
    }
  },

  changeBackground({ state, commit }, payload) {
    firebase
      .firestore()
      .collection('users')
      .doc(state.user.uid)
      .set(
        {
          settings: {
            backgroundImage: payload.background,
            backgroundOpacity: payload.opacity,
          },
        },
        {
          merge: true,
        },
      )
      .then(() => {
        commit('changeBackground', payload);
      });
  },

  signoutUser({ state, commit }) {
    commit('setPersons', []);
    commit('setUser', null);
    commit('setUserData', null);
  },
};
